export default __webpack_public_path__ + "locales/bg/SharingPanel.json?hash=f370ef863a54cd3d20e6c47a6f39fa70";